import React from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const StatusConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  banner,
  loading,
}) => {
  if (!isOpen || !banner) return null;

  const isActivating = banner.newStatus === 1;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">

        {/* Header */}
        <div className="flex items-center gap-4 p-6 border-b">
          <div
            className={`w-10 h-10 rounded-md flex items-center justify-center ${
              isActivating ? "bg-green-500" : "bg-red-500"
            }`}
          >
            <Icon
              name={isActivating ? "CheckCircle" : "AlertTriangle"}
              size={20}
              color="white"
            />
          </div>
          <div>
            <h2 className="text-lg font-semibold">
              {isActivating ? "تأكيد التفعيل" : "تأكيد إلغاء التفعيل"}
            </h2>
            <p className="text-sm text-gray-500">
              {isActivating
                ? "هل أنت متأكد من تفعيل هذا البنر؟"
                : "هل أنت متأكد من إلغاء تفعيل هذا البنر؟"}
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="bg-gray-50 p-4 rounded border text-sm">
            <p className="font-medium break-all">{banner.url}</p>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 p-6 border-t">
          <Button variant="outline" onClick={onClose} disabled={loading}>
            إلغاء
          </Button>

          <Button
            onClick={onConfirm}
            loading={loading}
            className={
              isActivating
                ? "bg-green-600 hover:bg-green-700"
                : "bg-red-600 hover:bg-red-700"
            }
          >
            {isActivating ? "تفعيل" : "إلغاء التفعيل"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StatusConfirmationModal;